import type { TextareaDesignTokens, TextareaTokenSections } from '@openng/optimus-ui-themes/types/textarea';

export const root: TextareaTokenSections.Root = {
	invalidPlaceholderColor: '{surface.200}',
	placeholderColor: '{surface.200}',
};

export default {
	root,
} satisfies TextareaDesignTokens;
